
import React,{useState,useEffect} from "react";
import "./DashboardCard.css";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import LoadingButton from "../../../Loading/LoadingButton"; 
import { createRazorpayLinkedAccTempEntry } from "../../../../store/actions/CreateApp/getAllBusinessTypes";
const DashboardCardRLA =  ({ data, data2 }) => {
   const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
    const [loader , setLoader] =useState({status:false});
 
          
             const [razorPayResp, setRazorPayResp] = useState(data);
             const [userMobile, setUserMobile] = useState();
             const [razorPayRespTwo, setRazorPayRespTwo] = useState(data2);
              const currentToken = useSelector((state)=>state?.user?.user?.token);
              const user_email = useSelector((state)=>state?.user?.user?.user_email
             );
             const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
             const appId = useSelector((state)=>state?.app?.app?.ID);
             const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
                  
             const [snackbarVisible, setSnackbarVisible] = useState(false);
              
              const [snackbarColor, setSnackbarColor] = useState("#958FDA");
              const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
              const showSnackbar = () => {
               setSnackbarVisible(true);
             };
             
              const hideSnackbar = () => {
               setSnackbarVisible(false);
             };
            
               useEffect(()=>{
                   fireGetAccountDetails()
                  
                  },[])
                 const fireGetAccountDetails=()=>{
                  setLoader({status:true});
                      
                        const apiData = dispatch(createRazorpayLinkedAccTempEntry({userEmail:user_email,
                          editType:"getAccDataByuserId"
                          }));
                        /* get response as Promise   */
                        apiData.then(response => {
                          if(response){  
                          
                            if(response?.accData){
                              
                       setUserMobile(response?.accData?.contact_phone);
                      setLoader({status:false});
                         }else{
                          setResponseMessage("Something Went Wrong...");
                            
                          setSnackbarColor("#958FDA");
                       
                           
                      setLoader({status:false});
                      
                      setSnackbarVisible(true);
                      setTimeout(()=>{
                        
                        setSnackbarVisible(false);
                       
                         
                      },3000)
                         }
                            
                         
                         if(response?.logout){
                         
                          setResponseMessage("You are Logged Out!!!");
                            
                          setSnackbarColor("#958FDA");
                       
                           
                      setLoader({status:false});
                      
                      setSnackbarVisible(true);
                      setTimeout(()=>{
                        
                        setSnackbarVisible(false);
                       
                         
                      },3000)
                          setTimeout(()=>{
                            dispatch({type:"LOGOUT"});
                      
                          },3000)
                          
                        }
                      /* resetting Login input Fields */
                      
                          }else{
                            setResponseMessage("Something Went Wrong...");
                            
                            setSnackbarColor("#958FDA");
                         
                             
                        setLoader({status:false});
                        
                        setSnackbarVisible(true);
                        setTimeout(()=>{
                          
                          setSnackbarVisible(false);
                         
                           
                        },3000)    }
                      
                        }).catch(error => {
                       
                          //popup of error Info
                          setResponseMessage("Something Went Wrong...");
                            
                          setSnackbarColor("#958FDA");
                       
                           
                      setLoader({status:false});
                      
                      setSnackbarVisible(true);
                      setTimeout(()=>{
                        
                        setSnackbarVisible(false);
                       
                         
                      },3000)
                          console.error(error);
                        });
                
                   }


    const clickGetAccountDetailsInfo=()=>{
              setLoader({status:true});
                  
                    const apiData = dispatch(createRazorpayLinkedAccTempEntry({userEmail:user_email,phone:userMobile,
                     
                      editType:"mobile"
                      }));
                    /* get response as Promise   */
                    apiData.then(response => {
                      if(response){  
                      
                        if(response?.razorpay_response){
                         
                          setRazorPayResp(response?.razorpay_response)
                      setResponseMessage(response?.message);
                      setSnackbarColor("rgba(144, 202, 249,1)");
                    
                  setLoader({status:false});
                     }else{
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                     }
                        
                     
                     if(response?.logout){
                     
                      setResponseMessage("You are Logged Out!!!");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      setTimeout(()=>{
                        dispatch({type:"LOGOUT"});
                  
                      },3000)
                      
                    }
                  /* resetting Login input Fields */
                  
                      }else{
                        setResponseMessage("Something Went Wrong...");
                        
                        setSnackbarColor("#958FDA");
                     
                         
                    setLoader({status:false});
                    
                    setSnackbarVisible(true);
                    setTimeout(()=>{
                      
                      setSnackbarVisible(false);
                     
                       
                    },3000)    }
                  
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
            
               }

  const address = razorPayResp?.profile?.addresses?.registered || {};
  const settlements = razorPayRespTwo?.active_configuration?.settlements || {};
  const tnc = razorPayRespTwo?.tnc || {};




  return (<> <div className="card">
      {/* Header */}
      {razorPayRespTwo?.account_id?
   <>
      <div className="card-header">
        <h2>{razorPayResp?.customer_facing_business_name}</h2>
        <span className={`status ${razorPayRespTwo?.activation_status}`}>{razorPayRespTwo?.activation_status}</span>
      </div>

      {/* Main Details */}
       <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"15px",padding:"10px",}}>
  <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}>
    <p><strong>RazorPay Acc. ID:</strong> {razorPayRespTwo?.account_id}</p>
    <p>T&C <strong>Accepted:</strong> {tnc.accepted ? "Yes ✅" : "No ❌"}</p>
        </div>
  <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}>
      <p><strong>Bank Account No.:</strong> {settlements?.account_number?settlements?.account_number:"Not Verified"}</p>
      
<p><strong>IFSC:</strong> {settlements?.ifsc_code?settlements?.ifsc_code:"Not Verified"}</p>
      

        </div><div style={{display:"flex",justifyContent:"space-between",position:"relative"}}>
      <p><strong>Email:</strong> {razorPayResp?.email}</p>
        <p><strong>Phone:</strong> {razorPayResp?.phone}</p>
        
        </div>
<div style={{display:"flex",justifyContent:"space-between",position:"relative"}}>
     <p style={{padding:"5px  10px",borderRadius:"5px",background:"rgba(144, 202, 249,1)"}}> {razorPayResp?.profile?.category}</p>
          <p style={{padding:"5px 10px",borderRadius:"5px",background:"rgba(144, 202, 249,1)"}}> {razorPayResp?.profile?.subcategory}</p>
         {/* <p style={{padding:"5px 10px",borderRadius:"5px",background:"rgba(144, 202, 249,1)"}}>  {razorPayResp?.business_type}</p> */}
        
           </div>
        
        <div style={{display:"flex",justifyContent:"space-between",position:"relative",gap:"10px"}}>
     <h4 style={{width:"150px"}}>Registered Address</h4>
          <p>{address.street1}, {address.street2} {address.city}, {address.state} - {address.postal_code} {address.country}</p>   </div>
      
      </div>

   </>
:""}
{razorPayRespTwo?.activation_status!=="activated"?
 <><div  className="ikcraft_login-input-card">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Add Account Holder Mobile Number </span>
 <input onMouseEnter={handleMouseEnter}  type="email" 
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}} placeholder={`Account Holder Mobile Number`} 
  rows={1} name="courseTitle" value={userMobile} onChange={(e)=>setUserMobile(e.target.value)} />
 </div>

<div align="center" className="buttonsRazorpayLA" style={{position:"absolute",left:"0px",right:"0px",bottom:"0px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><div></div>

<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{clickGetAccountDetailsInfo()}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > <><LoadingButton  Load={loader?.status}/> {razorPayRespTwo?.account_id?"Re-submit":"Final Submit "}</></button>
</div></>:""}
    </div></>
  );
};

export default DashboardCardRLA;
